import { createContext } from "react";
import type { WebSocketContextType } from "./WebSocket.type.ts";

export const WebSocketContext = createContext<WebSocketContextType | null>(
  null,
);
